import {
  Component, ViewContainerRef, ReflectiveInjector, ComponentFactoryResolver, Input, Output, EventEmitter, AfterViewInit, ViewChild
} from '@angular/core';
import { SendToDeveloperComponent } from
  '../integrate/dialog_content/send_to_developer.component';
import { InstallAutomaticallyApprovalComponent } from '../integrate/dialog_content/install_automatically_approval.component';
import { InstallAutomaticallyComponent } from '../integrate/dialog_content/install_automatically.component';
import { InstallItMyselfComponent } from '../integrate/dialog_content/install_it_myself.component';
import { PostAutomaticInstallComponent } from '../integrate/dialog_content/post_automatic_install.component';


@Component({
  selector: 'yi-dynamic-dialog-content',
  entryComponents: [SendToDeveloperComponent, InstallAutomaticallyApprovalComponent,
    InstallAutomaticallyComponent, InstallItMyselfComponent, PostAutomaticInstallComponent],
  template: `
    <div #dynamicComponentContainer ></div>
  `,
})
export default class DialogDynamicComponent implements AfterViewInit {

  @Output() close: any = new EventEmitter();
  @Output() nextDialog: any = new EventEmitter();

  currentComponent = null;
  private localData;
  private hasViewLoaded = false;

  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef }) dynamicComponentContainer: ViewContainerRef;

  @Input() set componentData(data: any) {
    this.localData = data;
    if (this.hasViewLoaded) {
      this.loadComponent();
    }
  }

  constructor(private resolver: ComponentFactoryResolver) {
  }

  ngAfterViewInit(): void {
    this.loadComponent();
    this.hasViewLoaded = true;
  }

  private loadComponent() {
    if (!this.localData) {
      return;
    }

    // Inputs need to be in the following format to be resolved properly
    let inputProviders = [{ provide: Component, useValue: this.localData }];
    let resolvedInputs = ReflectiveInjector.resolve(inputProviders);

    // We create an injector out of the data we want to pass down and this components injector
    let injector = ReflectiveInjector.fromResolvedProviders(resolvedInputs, this.dynamicComponentContainer.parentInjector);

    // We create a factory out of the component we want to create
    let factory = this.resolver.resolveComponentFactory(this.localData);

    // We create the component using the factory and the injector
    let component = factory.create(injector);

    (component.instance as any).closeDialog.subscribe(() => {
      this.close.emit();
    });

    (component.instance as any).nextDialog.subscribe((nextComponent) => {
      this.nextDialog.emit(nextComponent);
    });

    // We insert the component into the dom container
    this.dynamicComponentContainer.insert(component.hostView);

    // Destroy the previously created component
    if (this.currentComponent) {
      this.currentComponent.destroy();
    }

    this.currentComponent = component;
  }
}
